import React from 'react';
import TemplateViewer from './TemplateViewer';

export const TermsOfUse = () => {
  return <TemplateViewer URL={'/termsOfUseTemplate.html'} />;
};
